import PropTypes from "prop-types";
import {ButtonPill, Kicker} from "@/base";
import CmsImageLoader from "@/base/CmsImageLoader";
import {css} from "@emotion/react";

const TwoColFocusBlade = ({entity, split_ratio, focus_side}) => {

    let focusSize = split_ratio.value === '60_40' ? 'size-md-6of10' : 'size-md-7of10';
    let otherSize = split_ratio.value === '60_40' ? 'size-md-4of10' : 'size-md-3of10';

    const renderItems = (col) => {
        let columnItems = entity.value.elements.find(el=>el.render_name===col);

        return columnItems?.value?.elements.map((item)=>{

            if(item.render_name === 'kicker'){
                return <Kicker key={`kicker_${item.id}`}>{item.value}</Kicker>
            }

            if(item.render_name === 'basic_html'){
                return <div key={`basic_html_${item.id}`} dangerouslySetInnerHTML={{__html:item.value}}/>
            }

            if(item.render_name === 'image'){
                let imageUrl = item.value.elements.find(subEl=>subEl.render_name==='image_url');
                let altText = item.value.elements.find(subEl=>subEl.render_name==='alt_text');
                let imageMax = css(`
                    max-width: 100%;
                    img{
                        max-width: 100%
                    }
                `)

                return <div key={`image_${item.id}`} className={'mb-2'} css={imageMax}>
                    <CmsImageLoader url={imageUrl.value} alt={altText.value} /></div>
            }

            if(item.render_name === 'button'){

                let buttonUrl = item.value.elements.find(subEl=>subEl.render_name==='button_url');
                let buttonText = item.value.elements.find(subEl=>subEl.render_name==='button_text');
                let buttonTheme = item.value.elements.find(subEl=>subEl.render_name==='button_theme');

                return <ButtonPill key={`button_${item.id}`} to={buttonUrl.value} buttonTheme={buttonTheme.value}>{buttonText.value}</ButtonPill>
            }
        })
    }

    const lastChildCatch = css(`
        > div:last-child, > div:last-child > *:last-child {
            margin-bottom: 0px !important;
        }
    `)

    return (
        <div data-aos={"fade-up"} className="container py-4">
            <div className={'row'}>
                <div css={lastChildCatch} className={`size-full ${focus_side.value === 'first' ? focusSize : otherSize } pb-3 pb-md-0 d-flex flex-column justify-content-center`}>
                    {renderItems('column_one')}
                </div>
                <div css={lastChildCatch} className={`size-full ${focus_side.value === 'first' ? otherSize : focusSize } d-flex flex-column justify-content-center`}>
                    {renderItems('column_two')}
                </div>
            </div>
        </div>
    );
};

TwoColFocusBlade.propTypes = {
    entity: PropTypes.object,
    split_ratio: PropTypes.object,
    focus_side: PropTypes.object,
    column_one: PropTypes.object,
    column_two: PropTypes.object
};

export default TwoColFocusBlade;
